<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2022-03-07 20:10:36
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-22 15:46:56
-->

<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <el-table v-loading="loadRoles" :data="roles" style="width: 100%">
        <el-table-column label="序号" width="80" align="center" fixed>
          <template slot-scope="scope">
            {{
              (pagination.currentPage - 1) * pagination.pageSize +
              (scope.$index + 1)
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="roleTypeName"
          label="类型"
          min-width="10%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="roleName"
          label="角色名称"
          min-width="10%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="roleRemark"
          label="角色描述"
          min-width="10%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="deployNum"
          label="已配账户数量"
          min-width="10%"
          align="center"
        >
        </el-table-column>
        <el-table-column label="操作" min-width="10%" align="center">
          <div slot-scope="{ row }">
            <el-button
              type="primary"
              plain
              round
              size="mini"
              @click="toDetail(row)"
            >
              查看详情</el-button
            >
          </div>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,prev, pager, next,jumper"
        :page-size="this.pagination.pageSize"
        :total="pagination.recordTotal"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
      <DetailRole
        v-if="dialogRoleDetailVisible"
        :systemType="systemType"
        :showList="true"
        :dialogRoleDetailVisible="dialogRoleDetailVisible"
        :curRoleDetail="curRoleDetail"
        @close="close"
      ></DetailRole>
    </div>
  </el-main>
</template>

<script>
import DetailRole from "@/views/Setting/RoleManagement/components/DetailRole";
export default {
  name: "RoleList",
  props: {
    systemType: {
      type: Number,
      default: 3,
    },
  },
  components: { DetailRole },
  data() {
    return {
      roles: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      loadRoles: false,
      dialogRoleDetailVisible: false,
      curRoleDetail: {},
      masterId: "",
    };
  },
  created() {
    let { $businessAccountId } = this.$route.query;
    this.masterId = $businessAccountId;
    this.getRoleList();
  },
  computed: {},
  methods: {
    /**
     * @description:
     * @Author: yangsibo
     * @Date: 2022-06-07 14:42:19
     * @param {*} val
     */
    handleCurrentChange(val) {
      this.pagination.page = val;
      // this.getBdOrderList();
    },
    /**
     * @description: 查看详情
     * @Author: yangsibo
     * @Date: 2022-06-06 14:50:28
     * @param {*} id 角色id
     */
    toDetail(item) {
      this.curRoleDetail = item;
      this.dialogRoleDetailVisible = true;
    },
    /**
     * @description: 获取角色列表
     * @Author: yangsibo
     * @Date: 2022-05-23 17:45:52
     * @return {*}
     */
    async getRoleList() {
      this.loadRoles = true;
      this.roles = [];
      try {
        let { data } = await this.$http.role.getSRoleListNum({
          ...this.pagination,
          systemType: this.systemType,
          masterId: this.masterId,
        });
        if (data) {
          let { recordTotal, content: roles } = data;
          this.pagination.recordTotal = recordTotal;
          this.roles = roles;
        }
        this.loadRoles = false;
      } catch (error) {
        this.loadRoles = false;
      }
    },
    /**
     * @description:
     * @Author: yangsibo
     * @Date: 2022-06-09 10:50:18
     * @return {*}
     */
    close() {
      this.dialogRoleDetailVisible = false;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped></style>
